module.exports = __webpack_public_path__ + "static/media/call-gray.e0dab2c8.svg";